<template>
  <transition name="fade">
    <div class="pnlDialogFull" v-show="show" style="animation-duration: 0.2s">
      <div class="pnlDialogGray" @click.self="CloseDialog">
        <div class="pnlDialogSet">
          <div class="pnlAddTitle">
            <label>{{ title }}</label>
            <img
              class="btnDialogXX"
              src="@/assets/img/icon_btn/btn_close.png"
              @click="CloseDialog"
            />
          </div>
          <div class="pnlAddTxt">
            <input
              class="txtbSetName"
              :placeholder="inputPlaceholder"
              v-on:keyup.enter="BtnClick"
              v-on:keyup.esc="CloseDialog"
              v-model.trim="childInputText"
              ref="input"
            />
            <div class="pnlBtnArea">
              <button class="btnAddConfirm" @click="BtnClick">
                {{ btnText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "DialogOneKeyin",
  props: {
    show: Boolean,
    title: String,
    inputText: String,
    inputPlaceholder: String,
    btnText: String,
  },
  data() {
    return {
      childInputText: this.inputText,
    };
  },
  watch: {
    inputText(val) {
      this.childInputText = val;
    },
    show(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.input.focus();
        }, 250);
      }
    },
  },
  methods: {
    CloseDialog() {
      this.$emit("close-dialog");
    },
    BtnClick() {
      var data = {
        name: this.childInputText,
      };
      this.$emit("btn-click", data);
    },
  },
};
</script>